import * as React from "react";
const IconBs = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 513 342"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path  d="M0 0h513v342H0z" />
    <path  d="M0 0h513v114H0zm0 228h513v114H0z" />
    <path d="M256 171 0 342V0z" />
  </svg>
);
export default IconBs;
